module.exports = __webpack_public_path__ + "static/media/Kanit-Italic.729f2f68.ttf";